import { openDialog } from '../base/dialog/actions';
import { toggleScreensharing } from '../base/tracks/actions.web';
import { showNotification } from '../notifications/actions';
import { NOTIFICATION_TYPE } from '../notifications/constants';
import { SET_SCREENSHARE_TRACKS, SET_SCREEN_AUDIO_SHARE_STATE } from './actionTypes';
import ShareMediaWarningDialog from './components/web/ShareScreenWarningDialog';
import { isAudioOnlySharing, isScreenVideoShared } from './functions';
export * from './actions.any';
/**
 * Updates the current known status of the shared video.
 *
 * @param {boolean} isSharingAudio - Is audio currently being shared or not.
 * @returns {{
 *     type: SET_SCREEN_AUDIO_SHARE_STATE,
 *     isSharingAudio: boolean
 * }}
 */
export function setScreenAudioShareState(isSharingAudio) {
    return {
        type: SET_SCREEN_AUDIO_SHARE_STATE,
        isSharingAudio
    };
}
/**
 * Updates the audio track associated with the screenshare.
 *
 * @param {JitsiLocalTrack} desktopAudioTrack - The audio track captured from the screenshare.
 * @returns {{
 *      type: SET_SCREENSHARE_TRACKS,
 *      desktopAudioTrack: JitsiTrack
 * }}
 */
export function setScreenshareAudioTrack(desktopAudioTrack) {
    return {
        type: SET_SCREENSHARE_TRACKS,
        desktopAudioTrack
    };
}
/**
 * Start the audio only screen sharing flow. Function will switch between off and on states depending on the context.
 *
 * @param {Object} state - The state of the application.
 * @returns {void}
 */
export function startAudioScreenShareFlow() {
    return (dispatch, getState) => {
        const state = getState();
        const audioOnlySharing = isAudioOnlySharing(state);
        // If we're already in a normal screen sharing session, warn the user.
        if (isScreenVideoShared(state)) {
            dispatch(openDialog('ShareMediaWarningDialog', ShareMediaWarningDialog, { _isAudioScreenShareWarning: true }));
            return;
        }
        /*
                // If users opted out of the helper dialog toggle directly.
                // If we're in an electron environment the helper dialog is not needed as there's only one option
                // available for audio screen sharing, namely full window audio.
                // If we're already sharing audio, toggle off.
                if (shouldHideShareAudioHelper(state) || browser.isElectron() || audioOnlySharing) {
                    // We don't want to explicitly set the screens share state, by passing undefined we let the
                    // underlying logic decide if it's on or off.
                    //dispatch(toggleScreensharing(undefined, true));
        
                    //return;
                    
                }
        
                dispatch(openDialog('ShareAudioDialog', ShareAudioDialog));
         */
        //MS, voglio che si vada direttamente sul dialog di condivisione audio senza alcuna condizione.
        //Bolognini non vuole passare dal dialog col video dimostrativo quindi commento tutto l'if precedente compresa la dispatch(openDialog(ShareAudioDialog)) ed estrapolo solo la toggleScreensharing 
        dispatch(toggleScreensharing(undefined, true));
    };
}
/**
 * Start normal screen sharing flow.Function will switch between off and on states depending on the context, and if
 * not explicitly told otherwise.
 *
 * @param {boolean} enabled - Explicitly set the screen sharing state.
 * @returns {void}
 */
export function startScreenShareFlow(enabled) {
    return (dispatch, getState) => {
        const state = getState();
        const audioOnlySharing = isAudioOnlySharing(state);
        // If we're in an audio screen sharing session, warn the user.
        if (audioOnlySharing) {
            dispatch(openDialog('ShareMediaWarningDialog', ShareMediaWarningDialog, { _isAudioScreenShareWarning: false }));
            return;
        }
        if (enabled) {
            //MS aggiunta di un controllo per limitare ad una condivisione schermo alla volta
            const regex = /^participant_[a-zA-Z0-9]+-v\d+$/;
            const exists = Array.from(document.querySelectorAll('span[id]')).some(span => regex.test(span.id));
            //console.log("🔎 Esiste almeno uno span che matcha? ", exists);
            const isRecording = document.querySelector('[class*="-record"]');
            //console.log("🎥 C'è una registrazione attiva?", isRecording);
            if (exists && isRecording) {
                dispatch(showNotification({
                    titleKey: 'dialog.screenSharingLimit',
                    descriptionKey: 'dialog.screenSharingLimitDescription',
                    appearance: NOTIFICATION_TYPE.WARNING
                }));
                return;
            }
        }
        dispatch(toggleScreensharing(enabled));
    };
}
